import { render, staticRenderFns } from "./orphaned_items.vue?vue&type=template&id=beac9368&"
import script from "./orphaned_items.vue?vue&type=script&lang=js&"
export * from "./orphaned_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports